export const OFFICE_STANDALONE_NAV_KEY = 'officeNavStandalone';

export function clearOfficeStandaloneNav(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(OFFICE_STANDALONE_NAV_KEY);
}

export function markOfficeStandaloneNav(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(OFFICE_STANDALONE_NAV_KEY, '1');
}

export function isOfficeStandaloneNav(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(OFFICE_STANDALONE_NAV_KEY) === '1';
}
